// POLYFILL for Promise.withResolvers - MUST BE FIRST
if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

import AppRevatech from './index';
import Keycloak from "keycloak-js";
import {findGroupNameByUsersId} from "./services/userService";

if (process.env.VUE_APP_KEYCLOAK_ENABLED === 'true') {
  mountAppAndModulesWithKeycloak();
} else {
  mountAppAndModules();
}

async function mountAppAndModulesWithKeycloak() {
  const initOptions = {
    url: process.env.VUE_APP_KEYCLOAK_URL,
    realm: process.env.VUE_APP_KEYCLOAK_REALM,
    clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID
  };

  const keycloak = new Keycloak(initOptions);

  keycloak.init({onLoad: 'login-required', responseMode: 'query',checkLoginIframe: true, enableLogging: true,})
      .then(auth => {
        if (!auth) {
          console.error("Unable to authenticate");
        } else {
          console.log('login-required');

          const url = new URL(window.location.href);
          url.searchParams.delete('state');
          url.searchParams.delete('session_state');
          url.searchParams.delete('code');
          window.history.replaceState({}, document.title, url.pathname + url.hash);

          console.log("Authenticated");

          localStorage.setItem('vue-token', keycloak.token);

          initAppAndModulesSecurityStore(keycloak);

          mountAppAndModules();

          initKeycloakTokenAutoRefresh(keycloak);

          groupNameByUsersId(keycloak);

          loadUserPreference(keycloak).then(preferences => {
            initUserPreference(preferences);
          });
        }
      })
      .catch(error => {
        console.error('Authentication Failed', error);
        document.body.innerHTML = `<h3 style="color:red; padding:20px;">Auth Error: ${error}</h3>`;
      });
}

function initUserPreference(userPreferences) {
  AppRevatech.$store.dispatch('userPreference/setUserPreferenceInstance', userPreferences);
  AppRevatech.offersVueInstance.$store.dispatch('userPreference/setUserPreferenceInstance', userPreferences);
  AppRevatech.treatmentsVueInstance.$store.dispatch('userPreference/setUserPreferenceInstance', userPreferences);
  AppRevatech.deliveriesVueInstance.$store.dispatch('userPreference/setUserPreferenceInstance', userPreferences);
  AppRevatech.invoicesVueInstance.$store.dispatch('userPreference/setUserPreferenceInstance', userPreferences);
  AppRevatech.preInvoicesVueInstance.$store.dispatch('userPreference/setUserPreferenceInstance', userPreferences);
  AppRevatech.exitProcessVueInstance.$store.dispatch('userPreference/setUserPreferenceInstance', userPreferences);
}

function mountAppAndModules() {
  AppRevatech.contactsVueInstance.$mount('#app-contacts');
  AppRevatech.offersVueInstance.$mount('#app-offers');
  AppRevatech.treatmentsVueInstance.$mount('#app-analyses');
  AppRevatech.deliveriesVueInstance.$mount('#app-planning');

  AppRevatech.preInvoicesVueInstance.$mount('#app-pre-invoices');
  AppRevatech.invoicesVueInstance.$mount('#app-invoices');
  AppRevatech.exitProcessVueInstance.$mount('#app-exitprocess');
  AppRevatech.$mount('#app-revatech');
}

function loadUserPreference(keycloakInstance) {
  return new Promise((resolve) => {
    let preferences = {};

    keycloakInstance.loadUserProfile()
        .then(userProfile => {
          if (userProfile.attributes?.language?.length > 0 && userProfile.attributes.language[0]) {
            let language = userProfile.attributes.language[0];
            if (language) {
              preferences['language'] = language;
            }
          } else {
            preferences['language'] = 'EN';
          }

          if (userProfile.attributes?.site?.length > 0 && userProfile.attributes.site[0]) {
            let site = userProfile.attributes.site[0];
            if (site) {
              preferences['site'] = site;
              setSite(site);
            }
          } else {
            preferences['site'] = 'ENGIS_DIVISION';
            setSite('ENGIS_DIVISION');
          }

          if (userProfile.username) {
            preferences['username'] = userProfile.username;
          }
          if (userProfile.email) {
            preferences['email'] = userProfile.email;
          }
          if(userProfile.lastName){
            preferences['lastName'] = userProfile.lastName;
          }
          if(userProfile.firstName){
            preferences['firstName'] = userProfile.firstName;
          }

          resolve(preferences);
        })
        .catch(err => {
          console.warn("Failed to load user profile", err);
          // Resolve with defaults so app doesn't hang
          preferences['language'] = 'EN';
          preferences['site'] = 'ENGIS_DIVISION';
          resolve(preferences);
        });
  });
}

function setSite(site) {
  AppRevatech.deliveriesVueInstance.$store.dispatch('deliveryList/removeOrAddSite', site);
  AppRevatech.offersVueInstance.$store.dispatch('offerList/removeOrAddSite', site);
  AppRevatech.treatmentsVueInstance.$store.dispatch('treatmentList/removeOrAddSiteTreatment', site);
  AppRevatech.treatmentsVueInstance.$store.dispatch('analysisList/removeOrAddSiteAnalysis', site);
  AppRevatech.treatmentsVueInstance.$store.dispatch('certificateList/removeOrAddSiteCertificate', site);
  AppRevatech.preInvoicesVueInstance.$store.dispatch('invoiceList/removeOrAddSitePreInvoice', site);
  AppRevatech.invoicesVueInstance.$store.dispatch('invoiceList/removeOrAddSiteInvoice', site);
  AppRevatech.exitProcessVueInstance.$store.dispatch('exitList/removeOrAddSiteExit', site);
  AppRevatech.exitProcessVueInstance.$store.dispatch('flowList/removeOrAddSiteFlow', site);
}

function initAppAndModulesSecurityStore(keycloakInstance) {
  AppRevatech.contactsVueInstance.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
  AppRevatech.offersVueInstance.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
  AppRevatech.treatmentsVueInstance.$store.dispatch('security/setKeycloakInstance', keycloakInstance);

  AppRevatech.deliveriesVueInstance.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
  AppRevatech.invoicesVueInstance.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
  AppRevatech.preInvoicesVueInstance.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
  AppRevatech.exitProcessVueInstance.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
  AppRevatech.$store.dispatch('security/setKeycloakInstance', keycloakInstance);
}

function setGroupForRolesSecurityStore(userGroup) {
  AppRevatech.contactsVueInstance.$store.dispatch('security/setUserGroupForRolesInstance', userGroup);
  AppRevatech.offersVueInstance.$store.dispatch('security/setUserGroupForRolesInstance', userGroup);
  AppRevatech.treatmentsVueInstance.$store.dispatch('security/setUserGroupForRolesInstance', userGroup);

  AppRevatech.deliveriesVueInstance.$store.dispatch('security/setUserGroupForRolesInstance', userGroup);
  AppRevatech.invoicesVueInstance.$store.dispatch('security/setUserGroupForRolesInstance', userGroup);
  AppRevatech.preInvoicesVueInstance.$store.dispatch('security/setUserGroupForRolesInstance', userGroup);
  AppRevatech.exitProcessVueInstance.$store.dispatch('security/setUserGroupForRolesInstance', userGroup);
}

function initKeycloakTokenAutoRefresh(keycloakInstance) {
  setInterval(async () => {
    try {
      await keycloakInstance.updateToken(70);
      localStorage.setItem('vue-token', keycloakInstance.token);
      initAppAndModulesSecurityStore(keycloakInstance);
    } catch (error) {
      console.error('Failed to refresh token', error);
    }
  }, 5000);
}

function groupNameByUsersId(keycloak) {
  if (keycloak.tokenParsed && keycloak.tokenParsed.sub) {
    findGroupNameByUsersId(keycloak.tokenParsed.sub).then(
        response => {
          let userGroups = response.map(group => group.name);
          setGroupForRolesSecurityStore(userGroups);
        }
    ).catch(err => {
      console.error("Failed to load user groups", err);
    });
  }
}
